import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, FormControl } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

const FieldInputDate = ({ input, name, label, meta: { touched, error, warning }, focus, inputGroup, isDisabled, handleChange, defaultDate }) => {
    return (
        <>
            <Form.Label htmlFor={name}>{label}</Form.Label>
            <InputGroup>
                {inputGroup ? <InputGroup.Prepend>
                    <InputGroup.Text id="inputGroupPrepend">{inputGroup}</InputGroup.Text>
                </InputGroup.Prepend> : null}

                {
                    
                    !!handleChange ?

                        <DatePicker className="form-control"
                            name={name}
                            disabled={isDisabled}
                            onChange={handleChange}
                            selected={defaultDate}
                            dateFormat="dd/MM/yyyy"
                        /> :
                        <DatePicker
                            name={name}
                            disabled={isDisabled}
                            selected={defaultDate}
                            dateFormat="dd/MM/yyyy"
                        />

                }

            </InputGroup>
            {touched && ((error && <p className="text-danger">{error}</p>) || (warning && <p className="text-danger">{warning}</p>))}
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </>
    );
};

FieldInputDate.propTypes = {
    input: PropTypes.object.isRequired,
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    focus: PropTypes.bool,
    defaultValue: PropTypes.string,
    isDisabled: PropTypes.bool,
    handleChange: PropTypes.func,
    valorDefault: PropTypes.string,
    defaultDate: PropTypes.string
};



export default FieldInputDate;
